import globalServerIp from "./global";
import openSocket from "socket.io-client";
export const socket = openSocket.connect(`${globalServerIp.serverip}`,{ transports : ['websocket'], secure: true });
